export function ErrorSection({ children }: { children?: React.ReactNode }) {
  return (
    <div className="alert alert-danger" role="alert">
      {children}
    </div>
  );
}
